module.exports = __webpack_public_path__ + "static/img/关于隆携.584121c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/关于隆携.jpg
// module id = +5Ii
// module chunks = 1